import { isPlainObject, visitObjects } from '../helpers/helpers';

interface SvgAsset {
  url: string;
  filename: string;
  content_type: string;
  svgData?: string | null;
}

const SVG_CONTENT_TYPE = 'image/svg+xml';

const svgMarkupRequestsByUrl = new Map<string, Promise<string | null>>();

const isSvgWithoutMarkup = (value: unknown): value is SvgAsset =>
  isPlainObject(value) &&
  typeof value.url === 'string' &&
  typeof value.filename === 'string' &&
  value.content_type === SVG_CONTENT_TYPE &&
  !value.svgData;

const fetchSvgMarkup = (url: string): Promise<string | null> => {
  const existingRequest = svgMarkupRequestsByUrl.get(url);

  if (existingRequest) return existingRequest;

  const request = fetch(url)
    .then((response) => (response.ok ? response.text() : null))
    .catch(() => null);

  svgMarkupRequestsByUrl.set(url, request);

  return request;
};

const findSvgsWithoutMarkup = (data: unknown): SvgAsset[] => {
  const svgs: SvgAsset[] = [];

  visitObjects(data, (object) => {
    if (!isSvgWithoutMarkup(object)) return undefined;

    svgs.push(object);

    return 'skipChildren';
  });

  return svgs;
};

export const addSvgMarkup = async (data: unknown): Promise<void> => {
  const svgs = findSvgsWithoutMarkup(data);

  await Promise.all(
    svgs.map(async (svg) => {
      const markup = await fetchSvgMarkup(svg.url);

      if (markup) svg.svgData = markup;
    })
  );
};
